import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

export default class extends React.Component {
    static propTypes = {
		banner: PropTypes.string.isRequired,
		thumbnail: PropTypes.string,
		square: PropTypes.string,
	};

    render() {
		return (
			<img src={this.props.full} className="img-responsive" />
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Article/components/FeaturedImage.js